import React, { useState } from 'react';
import './App.css';
import './styles/blobButton.css';
import './styles/responsive.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ContactFormModal from './components/ContactFormModal';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import BookSlider from './components/BookSlider';
import Services from './components/Services';
import DiscountBanner from './components/DiscountBanner';
import BlogsAndNews from './components/AuthorServices';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Statistics from './components/Statistics';
import Footer from './components/Footer';
import BackgroundSamples from './components/BackgroundSamples';
import AnimatedBackground from './components/AnimatedBackground';
import ScrollToTop from './components/ScrollToTop';
import BookWriting from './pages/BookWriting';
import BookPublishing from './pages/BookPublishing';
import BookEditing from './pages/BookEditing';
import BookMarketing from './pages/BookMarketing';
import AudiobookProduction from './pages/AudiobookProduction';
import BookDesign from './pages/BookDesign';
import BookPrinting from './pages/BookPrinting';
import BookVideoTrailer from './pages/BookVideoTrailer';
import WebDesignSEO from './pages/WebDesignSEO';
import IllustrationServices from './pages/IllustrationServices';
import ArticleServices from './pages/ArticleServices';
import BlogWritingServices from './pages/BlogWritingServices';
import WebContentWriting from './pages/WebContentWriting';
import AboutUs from './pages/AboutUs';
import Blog from './pages/Blog';
// import NewsUpdates from './pages/NewsUpdates'; // Replaced with NewsList
import ContactUs from './pages/ContactUs';
import LPBookPublishing from './pages/LPBookPublishing';
import LPBookWriting from './pages/LPBookWriting';
import LPBookMarketing from './pages/LPBookMarketing';
import LPBookAudiobook from './pages/LPBookAudiobook';
import LPBookEditing from './pages/LPBookEditing';
import LPBookDesign from './pages/LPBookDesign';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import DisclaimerPolicy from './pages/DisclaimerPolicy';
import SignupThankYou from './pages/SignupThankYou';
import BlogList from './pages/blog/BlogList';
import ArtOfStorytelling from './pages/blog/ArtOfStorytelling';
import SelfPublishingVsTraditional from './pages/blog/SelfPublishingVsTraditional';
import BookMarketingStrategies from './pages/blog/BookMarketingStrategies';
import NewsList from './pages/news/NewsList';
import NewDistributionPartnership from './pages/news/NewDistributionPartnership';

function HomePage({ onOpenModal }) {
  return (
    <>
      <AnimatedBackground />
      <div id="home">
        <Hero />
      </div>
      <BookSlider />
      <div id="services">
        <Services />
      </div>
      <DiscountBanner onOpenModal={onOpenModal} />
      <div id="portfolio">
        <Portfolio />
      </div>
      <div id="statistics">
        <Statistics />
      </div>
      <div id="testimonials">
        <Testimonials />
      </div>
      <BlogsAndNews />
    </>
  );
}

function App() {
  const location = useLocation();
  const isLandingPage = location.pathname.startsWith('/lp/');
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <HelmetProvider>
      <div className="App">
      {!isLandingPage && <Navigation onOpenModal={() => setIsModalOpen(true)} />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage onOpenModal={() => setIsModalOpen(true)} />} />
        <Route path="/book-writing" element={<BookWriting />} />
        <Route path="/book-publishing" element={<BookPublishing />} />
        <Route path="/book-editing" element={<BookEditing />} />
        <Route path="/book-marketing" element={<BookMarketing />} />
        <Route path="/audiobook-production" element={<AudiobookProduction />} />
        <Route path="/book-design" element={<BookDesign />} />
        <Route path="/book-printing" element={<BookPrinting />} />
        <Route path="/book-video-trailer" element={<BookVideoTrailer />} />
        <Route path="/web-design-seo" element={<WebDesignSEO />} />
        <Route path="/illustration-services" element={<IllustrationServices />} />
        <Route path="/article-services" element={<ArticleServices />} />
        <Route path="/blog-writing-services" element={<BlogWritingServices />} />
        <Route path="/web-content-writing" element={<WebContentWriting />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        {/* <Route path="/news-updates" element={<NewsUpdates />} /> */}
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/lp/book-publishing" element={<LPBookPublishing />} />
        <Route path="/lp/book-writing-service" element={<LPBookWriting />} />
        <Route path="/lp/book-marketing-service" element={<LPBookMarketing />} />
        <Route path="/lp/audiobook-service" element={<LPBookAudiobook />} />
        <Route path="/lp/book-editing-service" element={<LPBookEditing />} />
        <Route path="/lp/book-design-service" element={<LPBookDesign />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/disclaimer-policy" element={<DisclaimerPolicy />} />
        <Route path="/Signup-Thankyou" element={<SignupThankYou />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/art-of-storytelling" element={<ArtOfStorytelling />} />
        <Route path="/blog/self-publishing-vs-traditional" element={<SelfPublishingVsTraditional />} />
        <Route path="/blog/book-marketing-strategies-2025" element={<BookMarketingStrategies />} />
        <Route path="/news-updates" element={<NewsList />} />
        <Route path="/news/new-distribution-partnership" element={<NewDistributionPartnership />} />
        <Route path="/samples" element={<BackgroundSamples />} />
      </Routes>
      {!isLandingPage && <Footer />}
      
      {/* SVG Gooey Filter for Blob Button Animation */}
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ display: 'none' }}>
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
            <feBlend in2="goo" in="SourceGraphic" result="mix" />
          </filter>
        </defs>
      </svg>

      {/* Centralized Contact Form Modal */}
      <ContactFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div>
    </HelmetProvider>
  );
}

export default App;